import * as React from 'react';
import { makeStyles } from '@fluentui/react-components';

interface LoadingIconProps {
  /** Pixel size for the rendered icon. Defaults to 24px (matches inline text). */
  size?: number;
  alt?: string;
}

const useStyles = makeStyles({
  img: {
    display: 'inline-block',
    objectFit: 'contain',
    flexShrink: 0,
  },
});

const LoadingIcon: React.FC<LoadingIconProps> = ({ size = 24, alt = 'Loading' }) => {
  const styles = useStyles();
  return (
    <img
      className={styles.img}
      src="assets/signus-loading.gif"
      alt={alt}
      width={size}
      height={size}
      style={{ width: `${size}px`, height: `${size}px` }}
    />
  );
};

export default LoadingIcon;
